import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CardLoader from '../../../design-system/loading/card/CardLoader';
import Button from '../../../design-system/button/Button';
import ExpandableDescription from './ExpandableDescription';
import Tip from './Tip';

import styles from './CoachCard.module.scss';
import { PERIOD_OF_THE_DAY } from '../../../availability/helpers';
import DescriptionModal from './DescriptionModal';

const CoachCard = ({ index, tutor, isLoading, onBook }) => {
  const [readMore, setReadMore] = useState(false);
  if (isLoading)
    return (
      <div className={[styles['card-wrapper'], styles.loading].join(' ')}>
        <CardLoader rows={4} rowsColor="gray" />
      </div>
    );

  const checkCoachAvailability = () => {
    if (!tutor?.availability_matrix || !Object.keys(tutor?.availability_matrix).length) return [];
    // Get the user's time zone offset in minutes
    const timeZoneOffsetInMinutes = new Date().getTimezoneOffset();

    // Convert the offset to hours and invert the sign (because JS gives the offset in minutes ahead of UTC, not behind)
    let timeZoneOffsetInHours = -timeZoneOffsetInMinutes / 60;

    // Round the offset to the nearest whole number (e.g., round +5:30 to +5)
    timeZoneOffsetInHours = Math.round(timeZoneOffsetInHours);

    const tutorAvailabilityForTimeZone = tutor.availability_matrix[timeZoneOffsetInHours];
    return tutorAvailabilityForTimeZone.reduce((acc, cv, index) => {
      console.log('cv', cv);
      const isAvailable = cv.some((value) => value);
      if (isAvailable) return [...acc, PERIOD_OF_THE_DAY[index]];
      return [...acc];
    }, []);
  };

  return (
    <>
      <div role="button" className={styles['card-wrapper']} onClick={() => setReadMore(true)}>
        <div className={styles['coach-presentation']}>{tutor?.photo && <img src={tutor?.photo} alt="" />}</div>
        <h3 className={styles['coach-name']} id={`coach-name-${index}`}>{`${tutor?.first_name} ${tutor?.last_name}`}</h3>
        <div className={styles['coach-availability']}>
          {checkCoachAvailability().map((av, index) => (
            <Tip key={index} label={av} />
          ))}
        </div>
        <div className={styles['coach-description']}>
          <ExpandableDescription openReadMore={() => setReadMore(true)} readMore={readMore} tutor={tutor} />
        </div>
        <div className={styles['book-button']}>
          <Button bold outfit="greenButton" onClick={() => onBook({ ...tutor })} id={`coach-${index}`}>
            BOOK
          </Button>
        </div>
        {typeof tutor?.isTutorAvailable === 'boolean' && !tutor?.isTutorAvailable && (
          <div className={styles['card-unavailability-tag']}>
            <p>Availability not matching</p>
          </div>
        )}
      </div>
      <DescriptionModal
        availability={checkCoachAvailability()}
        isModalOpen={readMore}
        onBook={onBook}
        onCloseModal={() => setReadMore(false)}
        tutor={tutor}
      />
    </>
  );
};

CoachCard.propTypes = {
  availability: PropTypes.array,
  index: PropTypes.number,
  tutor: PropTypes.object,
  isLoading: PropTypes.bool,
  onBook: PropTypes.func
};

export default CoachCard;
